import easings from '../../easings';
const MAX_Y_TRAVEL = 40;
const POWER_MAP = {
  soft: {
    scaleFrom: 0.8,
    scaleTo: 1.2,
    travelY: 0
  },
  medium: {
    scaleFrom: 0.3,
    scaleTo: 1.7,
    travelY: 0.75
  },
  hard: {
    scaleFrom: 0,
    scaleTo: 4,
    travelY: 1
  }
};
const RANGES_MAP = {
  in: (scaleFrom, _scaleTo, travelY) => ({
    fromValues: {
      scale: scaleFrom,
      travel: travelY
    },
    toValues: {
      scale: 1,
      travel: 0
    },
    scaleDelay: 60,
    scaleEase: 'sineIn'
  }),
  out: (_scaleFrom, scaleTo, travelY) => ({
    fromValues: {
      scale: 1,
      travel: 0
    },
    toValues: {
      scale: scaleTo,
      travel: -travelY
    },
    scaleDelay: 0,
    scaleEase: 'linear'
  }),
  continuous: (scaleFrom, scaleTo, travelY) => ({
    fromValues: {
      scale: scaleFrom,
      travel: travelY
    },
    toValues: {
      scale: scaleTo,
      travel: -travelY
    },
    scaleDelay: 22,
    scaleEase: 'sineInOut'
  })
};
function getScrubOffsets(_ref) {
  let {
    power,
    range = 'in',
    distance = 0
  } = _ref;
  const offset = power && POWER_MAP[power] ? POWER_MAP[power].travelY : Math.abs(distance) * MAX_Y_TRAVEL;
  return {
    start: range === 'out' ? '0px' : `${-offset}vh`,
    end: range === 'in' ? '0px' : `${offset}vh`
  };
}
export default function create(options) {
  const {
    power,
    range = 'in',
    scale = range === 'in' ? POWER_MAP.hard.scaleFrom : POWER_MAP.hard.scaleTo,
    distance = 0
  } = options.namedEffect;
  const easing = 'linear';
  const {
    scaleFrom,
    scaleTo,
    travelY
  } = power && POWER_MAP[power] ? POWER_MAP[power] : {
    scaleFrom: scale,
    scaleTo: scale,
    travelY: distance
  };
  const {
    fromValues,
    toValues,
    scaleDelay,
    scaleEase
  } = RANGES_MAP[range](scaleFrom, scaleTo, travelY * MAX_Y_TRAVEL);
  const scaleOffset = power === 'hard' ? scaleDelay / 100 : 0;
  const {
    start,
    end
  } = getScrubOffsets(options.namedEffect);
  return [{
    ...options,
    easing,
    startOffsetAdd: start,
    endOffsetAdd: end,
    keyframes: [{
      translate: `0 ${fromValues.travel}vh`
    }, {
      translate: `0 ${toValues.travel}vh`
    }]
  }, {
    ...options,
    easing: 'linear',
    // disable effect-wide easing and move easing into keyframes
    startOffsetAdd: start,
    endOffsetAdd: end,
    keyframes: [{
      offset: 0,
      scale: fromValues.scale
    }, {
      offset: scaleOffset,
      scale: fromValues.scale,
      easing: easings[scaleEase]
    }, {
      offset: 1,
      scale: toValues.scale
    }]
  }];
  /*
   * @keyframes <name> {
   *   from {
   *     translate: 0 <fromValues.travel>;
   *   }
   *   to {
   *     translate: 0 <toValues.travel>;
   *   }
   * }
   *
   * @keyframes <name>-scale {
   *   from {
   *     scale: <fromValues.scale>;
   *   }
   *   <scaleDelay>% {
   *     scale: <fromValues.scale>;
   *     animation-timing-function: <scaleEase>;
   *   }
   *   <scaleDuration>% {
   *     scale: <toValues.scale>;
   *   }
   *   to {
   *     scale: <toValues.scale>;
   *   }
   * }
   *
   * @supports (animation-timeline: view()) {
   *   #target {
   *     animation: <name> auto <easing> both,
   *                <name>-scale auto linear both;
   *     animation-range: cover <start> cover <end>,
   *                      cover <start> cover <end>;
   *     animation-timeline: view(), view();
   *   }
   * }
   * @supports not (animation-timeline: view()) {
   *   #target {
   *     animation: <name> 100ms linear both paused,
   *                <name>-scale 100ms linear both paused;
   *   }
   * }
   */
}
//# sourceMappingURL=GrowScroll.js.map